import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { Modal } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import API from "../../Services/BaseService";
import Loading from '../../Component/Loading/Loading';
import ErrorPopup from '../FallBackUI/ErrorPopup';


const CarHistory = (props) => {
  const sellerData = useSelector(state => state.LoginReducer.payload);
  const [historyDetails, setHistoryDetails] = useState([]);
  const [loading, setLoading] = useState(true);

  const [errors, setErrors] = useState("");
  const [errorFlag, setErrorFlag] = useState(false);

  const handleCarHistory = () => {
    let request = {
      // seller_dealer_id:sellerData.seller_dealer_id, 
      car_id: props.historycarId,
      seller_id: sellerData.seller_id,
      seller_token: sellerData.seller_token,
    }
    console.log("CarHistory request: ", request);
    API.post("carHistoryDetail/condition", request).then(response => {
      // setHistoryDetails(response.data.data);
      if (response.data.success === true) {
        setHistoryDetails(response.data.data.slice(0).sort(function compare(a, b) {
          var dateA = new Date(a.first_bid_date_tz);
          var dateB = new Date(b.last_bid_date_tz);
          return dateA - dateB;
        }))
        console.log("===CarHistory ===", response.data.data)
        console.log("===CarHistory response===", response.data.data.slice(0).sort(function compare(a, b) {
          var dateA = new Date(a.first_bid_date_tz);
          var dateB = new Date(b.last_bid_date_tz);
          return dateA - dateB;
        }))

      }
      else {
        setErrors(response.data.error.name)
        setErrorFlag(true)
      }
      setLoading(false)
    }).catch(function (error) {
      if (error.response) {
        setErrors(error.response.data.error)
        setErrorFlag(true)
        setLoading(false)

      }
    });
  }
  useEffect(() => {
    handleCarHistory();
  }, []);

  function formatTime(value) {
    let local = ""
    let offset = ""
    local = new Date(value);
    offset = local.getTimezoneOffset();
    value = new Date(local.getTime() - offset * 60000);
    value = moment(value).format('MMMM D, YYYY hh:mm A')
    return value;
  }

  return (

    <div>
      <Modal show={true} onHide={props.toggle}>
        <Modal.Header className="Terms-login">
          <h2>Car History</h2>
        </Modal.Header>
        <Modal.Body>
          {loading ? <Loading /> :

            <>
              {errorFlag === true ? <ErrorPopup error={errors} /> :
                <>
                  <div style={{ overflowX: 'auto' }}>
                    {historyDetails.length > 0 ? historyDetails.slice(0, 1).map((item) =>
                      <table class="bidinfo-table">
                        <thead className='Bidlist' >
                          <tr>
                            <th>Date</th>
                            <th>User Activities</th>
                            <th>Details</th>

                          </tr>
                        </thead>
                        <tr>
                          <td> {formatTime(item.carPostedAt_tz)} </td>
                          <td> Who posted car </td>
                          {/* <p>{make} ({model} model)</p> */}
                          <td><span>{item.car_postedBy} </span></td>
                        </tr>
                        <tr>
                          <td> {formatTime(item.first_bid_date_tz)} to {formatTime(item.last_bid_date_tz)}</td>
                          <td> How many bids, first bid to last bid </td>
                          <td><span> {item.noofBids}, {item.first_bid} to {item.last_bid} </span></td>
                        </tr>
                        <tr>
                          <td> {formatTime(item.first_bid_date_tz)}</td>
                          <td> First bid</td>
                          <td><span>{item.first_bid}</span></td>
                        </tr>
                        <tr>
                          <td> {formatTime(item.last_bid_date_tz)}</td>
                          <td>Last bid</td>
                          <td><span>{item.last_bid}</span></td>
                        </tr>
                        <tr>
                          <td> {formatTime(item.sell_it_now_createdAt_tz)}</td>
                          <td> Who gave this, how much given "sell it now"</td>
                          <td><span>{item.sell_it_now_createdBy}, {item.sell_it_now} </span></td>
                        </tr>
                        <tr>
                          <td> {formatTime(item.counter_bid_createdAt_tz)} </td>
                          <td> Who gave this, how much is the "counter bid"</td>
                          <td><span>{item.counter_bid_createdBy}, {item.counter_bid} </span></td>
                        </tr>
                        <tr>
                          <td> {formatTime(item.acceptedAt_tz)} </td>
                          <td> Who accepted the bid</td>
                          <td><span>{item.acceptedBy}</span></td>
                        </tr>
                        <tr>
                          <td> {item.transportation_appprovedAt}</td>
                          <td> Who approve the transportation / gatepass </td>
                          <td><span>{item.transportation_appprovedBy} / {item.gatepass_id}</span></td>
                        </tr>
                        {/* <tfoot>
             <tr>
               <td>Amount due to the seller</td>
               <td><span>${price  - getFeeDetails() + 0 + 0}</span></td>
             </tr>
             </tfoot> */}

                      </table>
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center bit-list">
                          <p>No Data Found</p>
                        </td>
                      </tr>
                    )}
                  </div>


                </>
              }
              <div class="Close-info">
                <button className="cta-btns-primary" onClick={props.toggle}>Close</button>

              </div>
            </>}

        </Modal.Body>
      </Modal>


    </div>
  )
}

export default CarHistory;